/**
 * Damage vignette: a full-screen red edge glow that flashes when the player
 * takes damage, then fades. Non-obstructing — it's a radial gradient that's
 * fully transparent through the centre and only reddens the screen edges, with
 * `pointer-events: none`. A DOM overlay (fixed, inset 0) so it always covers the
 * viewport without touching the Pixi stage / resize wiring.
 */
export class DamageVignette {
  private readonly el: HTMLDivElement;
  private strength = 0;

  constructor(parent: HTMLElement) {
    const el = document.createElement('div');
    el.className = 'damage-vignette';
    el.style.position = 'fixed';
    el.style.inset = '0';
    el.style.pointerEvents = 'none';
    el.style.opacity = '0';
    el.style.zIndex = '30';
    el.style.background =
      'radial-gradient(ellipse at center, rgba(255,0,0,0) 52%, rgba(150,10,10,0.35) 82%, rgba(230,20,20,0.7) 100%)';
    parent.appendChild(el);
    this.el = el;
  }

  /** Flash the vignette; `amount` in ~[0,1] scales the spike (bigger hit = brighter). */
  pulse(amount = 1): void {
    this.strength = Math.min(1, this.strength + Math.max(0, amount));
    this.el.style.opacity = String(this.strength);
  }

  /** Fade the flash out. Call each frame with the frame delta (seconds). */
  update(dtSec: number): void {
    if (this.strength <= 0) return;
    this.strength = Math.max(0, this.strength - dtSec * 2.2); // ~0.45s fade
    this.el.style.opacity = String(this.strength);
  }
}
